<template>
    <input 
        ref="input"
        v-if="editing"
        v-model.number="number"
        @blur="editing = false"
        @keyup.enter="editing = false"
        type="number"
    />
    <span v-else @click="editing = true">
        {{value}}{{suffix}}
    </span>
</template>

<script>
export default {
    name: 'editable-number',
    computed: {
        number: {
            get(){
                return this.value;
            },
            set(value){
                //input returns empty string if value is empty.
                if(value === '') {
                    value = 0;
                }
                if(this.higherThanMax()) {
                    value = this.max;
                }
                if(this.lowerThanMin()) {
                    value = this.min;
                }
                
                this.$emit('input', value);
            }
        },
        higherThanMax() {
            return this.max !== null && value > this.max;
        },
        lowerThanMin() {
            return this.min !== null && value < this.min;
        }
    },
    watch: {
        editing(value) {
            const vm = this;
            if(value) {
                vm.$nextTick(function () {
                    vm.$refs.input.focus();
                });
            }
        }
    },
    data() {
        return {
            editing: false
        };
    },
    props: {
        value: {
            type: Number,
            required: true
        },
        suffix: {
            type: String,
            default: ''
        },
        max: {
            type: Number,
            default: null
        },
        min: {
            type: Number,
            default: null
        }
    }
};
</script>
